type ArrowBackIosNewIconProps = React.SVGProps<SVGSVGElement>;

export const ArrowBackIosNewIcon: React.FC<ArrowBackIosNewIconProps> = (
  props
) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.77 3.77L16 2L6 12L16 22L17.77 20.23L9.54 12L17.77 3.77Z"
      fill="#424242"
    />
  </svg>
);
